import React from 'react';
import {connect} from 'react-redux';
import {BaseComponent as Component} from 'BaseComponent';
import {Factory} from './components/factory';

class FilterByGames extends Component {
    canComponentBeRendered() {
        const {sportConfig} = this.props;

        return sportConfig.isReady() && sportConfig.useGameFilter();
    }

    render() {
        if (!this.canComponentBeRendered()) {
            return null;
        }

        const {sportConfig} = this.props;
        const FilterByGamesComponent = Factory.getComponent(sportConfig);

        return <FilterByGamesComponent />;
    }
}

function mapStatesToProps(state) {
    const {
        sportConfig,
        teamsInfo,
        playersData: {games},
    } = state;

    return {
        sportConfig,
        games,
        teamsInfo,
    };
}

export default connect(mapStatesToProps)(FilterByGames);

export {FilterByGames};
